var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultActivityLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_11543_28373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0.200195C18.517 0.200195 23.7998 5.48304 23.7998 12C23.7998 18.517 18.517 23.7998 12 23.7998C5.48304 23.7998 0.200195 18.517 0.200195 12C0.200195 5.48304 5.48304 0.200195 12 0.200195Z",
    stroke: "#DFDFDF",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11543_28373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4004 12H16.1604C15.9419 11.9995 15.7292 12.0707 15.555 12.2025C15.3807 12.3343 15.2544 12.5196 15.1954 12.73L14.0204 16.91C14.0128 16.936 13.997 16.9588 13.9754 16.975C13.9538 16.9912 13.9274 17 13.9004 17C13.8733 17 13.847 16.9912 13.8254 16.975C13.8038 16.9588 13.788 16.936 13.7804 16.91L11.0204 7.09C11.0128 7.06404 10.997 7.04123 10.9754 7.025C10.9538 7.00877 10.9274 7 10.9004 7C10.8733 7 10.847 7.00877 10.8254 7.025C10.8038 7.04123 10.788 7.06404 10.7804 7.09L9.60539 11.27C9.54662 11.4796 9.42108 11.6643 9.24782 11.796C9.07456 11.9278 8.86305 11.9994 8.64539 12H7.40039",
    stroke: "#5A5A5A",
    strokeWidth: 0.93,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_11543_28373",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720046 0 0 0 0 0.720046 0 0 0 0 0.720046 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_11543_28373"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11543_28373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6.40039 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultActivityLogo);
export default __webpack_public_path__ + "static/media/default-activity-logo.2929bdaa1fc8f16e810aeb262a5ba154.svg";
export { ForwardRef as ReactComponent };